import type { DiagCategory } from "./types";

const PREFIX: Record<DiagCategory, string> = {
  startup: "STARTUP",
  auth: "AUTH",
  network: "NET",
  api: "API",
  database: "DB",
  wallet: "WALLET",
  bet: "BET",
  result: "RESULT",
  admin: "ADMIN",
  upload: "UPLOAD",
  notification: "PUSH",
  unknown: "APP",
};

const ALPHABET = "0123456789";

function randomSuffix(len = 6): string {
  let out = "";
  const g = typeof globalThis.crypto?.getRandomValues === "function" ? globalThis.crypto : null;
  if (g) {
    const buf = new Uint32Array(len);
    g.getRandomValues(buf);
    for (let i = 0; i < len; i++) out += ALPHABET[buf[i] % ALPHABET.length];
  } else {
    for (let i = 0; i < len; i++) out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return out;
}

/** Human-readable, category prefixed. e.g. AUTH-483920 */
export function newErrorId(category: DiagCategory): string {
  return `${PREFIX[category] ?? PREFIX.unknown}-${randomSuffix(6)}`;
}

/** Correlates one client action with its server-side records. */
export function newRequestId(): string {
  return `req_${Date.now().toString(36)}${randomSuffix(6)}`;
}

/** Stable-ish grouping key so identical failures collapse into one row group. */
export function groupHash(parts: Array<string | number | undefined | null>): string {
  const raw = parts.map((p) => String(p ?? "")).join("|");
  let h = 5381;
  for (let i = 0; i < raw.length; i++) h = ((h << 5) + h + raw.charCodeAt(i)) | 0;
  return `g${(h >>> 0).toString(16)}`;
}
